const alertContainer = document.getElementById('alert');

const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (
                node.nodeType === Node.ELEMENT_NODE &&
                node.classList.contains('alert-dismissible')
            ) {
                scheduleFadeOut(node);
            }
        }
    }
});

observer.observe(alertContainer, { childList: true });

function scheduleFadeOut(el) {
    el.style.transition = 'opacity 0.6s ease';

    setTimeout(() => {
        el.style.opacity = '0';
        el.addEventListener('transitionend', () => el.remove(), { once: true });
    }, 5000);
}